import {
  createClient,
  type FindOperation,
  getRequestFactory,
  postRequestFactory,
  type SaveOperation
} from '@infuse/api/common';

export interface ClaimChargingStationResponse {
  chargingStationId: string;
  chargingStationSerialNumber: string;
}

export interface ClaimChargingStationPayload {
  chargingStationId: string;
  password: string;
  rootId: string;
  parentId?: string;
}

const client = createClient('/rest');

export const claimingPermissions = {
  CLAIM: 'cpms.claim-charging-station'
};

export const claimChargingStation: SaveOperation<ClaimChargingStationPayload, ClaimChargingStationResponse> = postRequestFactory<
  ClaimChargingStationPayload, ClaimChargingStationResponse
>(client, {
  pattern: '/claiming/charging-stations',
  permissionId: claimingPermissions.CLAIM
});

export type ChargingStationClaimableResponse = { exists: boolean };

export const chargingStationClaimable: FindOperation<ChargingStationClaimableResponse, string> = getRequestFactory<
  ChargingStationClaimableResponse,
  string
>(client, {
  pattern: '/claiming/charging-stations/{id}/claimable',
  permissionId: claimingPermissions.CLAIM
});
